import React , { useContext} from 'react'; 
import Header from "src/components/common/Header";
import ClientForm from "src/components/client/ClientForm";
import { MenuContext } from 'src/context/MenuContext';
import Menu from "src/components/common/Menu";
import { useNavigate } from "react-router-dom";
import ScrollTop from 'src/components/common/ScrollTop';

export default function ClientInput() {
    const containerStyle = { width: "90%", margin: "0 auto" };
    const navigate = useNavigate();

    const clickClientListBtn = () => {
        navigate('/clientList');
    }

     // Destructuring correctly from menuContext
     const { visibleMenu} = useContext(MenuContext);
    return (
        <>
            {visibleMenu && <Menu />}
            <div className={visibleMenu ? 'menu-open' : 'menu-closed'}>
                <Header sx={{ mb: 500 }} />
                <section className="container-fluid contents-top client_input">
                    <div className="text-right">
                        <button type="button" className="btn btn-default" onClick={clickClientListBtn}>
                            <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                            Back to List
                        </button>
                    </div>
                    <div style={containerStyle}>
                        <h3 className="title-style01">New Client Registration</h3>
                        <ClientForm />
                    </div>
                </section>
            </div>
            <ScrollTop/>
        </>
    );
}
